import type { SpecDiffItem } from '../../services/specificationService';

export const FIELD_LABEL: Record<string, string> = {
  functionCode: '기능 코드',
  title: '제목',
  actor: 'Actor',
  precondition: '사전조건',
  postcondition: '사후조건',
  mainFlow: '주요 흐름',
  alternativeFlow: '대안 흐름',
  exceptionFlow: '예외 흐름',
  inputSpec: '상세 명세',
  outputSpec: '출력 명세',
  businessRules: '비즈니스 규칙',
  uiReference: 'UI 참조',
  status: '상태',
  requirementId: '연결 요구사항',
};

export function formatValue(value: unknown): string {
  if (value === null || value === undefined) return '(없음)';
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) {
    if (value.length === 0) return '(빈 배열)';
    // Flow steps or field specs
    if (typeof value[0] === 'object' && value[0] !== null) {
      return value
        .map((item, i) => {
          if ('action' in item) return `${item.step ?? i + 1}. ${item.action}`;
          if ('fieldName' in item) return `${item.fieldName} (${item.type})`;
          return JSON.stringify(item);
        })
        .join('\n');
    }
    return value.join('\n');
  }
  return JSON.stringify(value, null, 2);
}

export function DiffField({ diff }: { diff: SpecDiffItem }) {
  if (diff.type === 'unchanged') return null;

  const label = FIELD_LABEL[diff.field] ?? diff.field;
  const oldText = formatValue(diff.old);
  const newText = formatValue(diff.new);

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden">
      <div className="flex items-center gap-2 px-3 py-2 bg-gray-50 border-b border-gray-200">
        <span className="text-sm font-medium text-gray-700">{label}</span>
        <span
          className={`text-sm px-1.5 py-0.5 rounded font-medium ${
            diff.type === 'added'
              ? 'bg-green-100 text-green-700'
              : diff.type === 'removed'
                ? 'bg-red-100 text-red-700'
                : 'bg-yellow-100 text-yellow-700'
          }`}
        >
          {diff.type === 'added' ? '추가' : diff.type === 'removed' ? '삭제' : '수정'}
        </span>
      </div>
      <div className="grid grid-cols-2 divide-x divide-gray-200">
        {/* 이전 버전 */}
        <div className="p-3">
          <div className="text-sm text-gray-400 mb-1">이전</div>
          <pre
            className={`text-sm whitespace-pre-wrap font-mono leading-relaxed ${
              diff.type === 'removed' || diff.type === 'modified'
                ? 'bg-red-50 text-red-800 p-2 rounded line-through decoration-red-400'
                : 'text-gray-500'
            }`}
          >
            {oldText}
          </pre>
        </div>
        {/* 현재 버전 */}
        <div className="p-3">
          <div className="text-sm text-gray-400 mb-1">이후</div>
          <pre
            className={`text-sm whitespace-pre-wrap font-mono leading-relaxed ${
              diff.type === 'added' || diff.type === 'modified'
                ? 'bg-green-50 text-green-800 p-2 rounded'
                : 'text-gray-500'
            }`}
          >
            {newText}
          </pre>
        </div>
      </div>
    </div>
  );
}
